export type MemberStatus = 'Active' | 'Invited' | 'Disabled'
export type MemberSeat = 'Paid' | 'Free'
export type OrgRole = 'Loan Officer' | 'Admin' | 'Processor' | 'Owner' | 'Super Admin' | 'LO Manager' | 'Underwriter' | 'Closer'
export type OrgTabId = 'all' | string

export interface Organization {
  id: string
  customerId: string
  name: string
  short: string
  color: string
  address: string
  plan: string
  paidSeats?: number
  paidUsers?: number
  memberCount?: number
  isHardMoneyLoanCustomer?: boolean
  myRole: OrgRole
  roles: string[]
  canManageUsers: boolean
  canCreateOrganization: boolean
}

export interface Member {
  id: string
  email: string
  firstName: string
  lastName: string
  name: string
  nmls: string
  phone?: string
  accountTier?: string
  status: MemberStatus
  roles: Record<string, OrgRole>
  roleLists?: Record<string, OrgRole[]>
  organizationIds?: string[]
}

export interface OrgSelection {
  checked: boolean
  roles: OrgRole[]
}

export interface OrgChip {
  id: string
  label: string
  name?: string
  color: string
}

export interface MemberTableRow {
  member: Member
  roleInOrg: OrgRole
  roleChips: OrgChip[]
  orgChips: OrgChip[]
}

export interface MemberTableGroup {
  org: Organization
  rows: MemberTableRow[]
}

export interface MemberPage {
  members: Member[]
  total: number
  page: number
  pageSize: number
}

export interface MemberListFilters {
  roles: OrgRole[]
  organizationIds: string[]
  status: MemberStatus | ''
  accountTier: MemberSeat | ''
}

export const EMPTY_MEMBER_FILTERS: MemberListFilters = {
  roles: [],
  organizationIds: [],
  status: '',
  accountTier: '',
}

export interface InvitePayload {
  firstName: string
  lastName: string
  email: string
  nmls: string
  roles: Record<string, OrgRole[]>
}

export interface InviteOrganizationPayload {
  customerId: string
  roles: string[]
}

export interface InviteResult {
  customerId: string
  companyName?: string
  status: 'OK' | 'Error'
  exists?: boolean
  accountTier?: string
  text?: string
}

export interface EditUserPayload {
  customerId: string
  id: string
  firstName: string
  lastName: string
  email: string
  nmls: string
  roles: OrgRole[]
  accountTier?: string
}

export interface DisableUserPayload {
  customerId: string
  loanOfficerId: string
}

export interface AssignmentRecord {
  customerId: string
  loanOfficerId?: string
  companyName?: string
  checked: boolean
  status?: string
  roles?: string[]
}

export interface AssignOrganizationsPayload {
  sourceCustomerId: string
  sourceLoanOfficerId: string
  roles: Record<string, OrgRole[]>
}

export interface AssignOrganizationsResult {
  customerId: string
  companyName?: string
  status: 'OK' | 'Error'
  action?: 'created' | 'enabled' | 'updated' | 'disabled' | 'unchanged'
  loanOfficerId?: string
  accountTier?: string
  text?: string
}

export interface CreateOrgPayload {
  companyName: string
  street: string
  city: string
  state: string
  county: string
  zip: string
}

export interface OrganizationNameMatch {
  id: string
  name: string
}

export interface UserManagementProps {
  showUser?: boolean
  toLoans?: () => void
  toPricing?: () => void
}
